import constants from "../constants";

// Seems like overkill, but whatever...
const getTrackEvent = () => window.lp.analytics.send;

const pageView = ({ data }) => data.name;

const actionMap = {
  [constants.PAGE_VIEW]: pageView,
};

/**
 * Tracking middleware
 * When dispatching an action, add an `event` object into the action's `meta` to send data to GA
 * @example
 * // Action payload
 * {
 *   type: constants.SOME_ACTION
 *   meta: {
 *     event: {
 *       category: "",
 *       action: "",
 *       label: "",
 *     },
 *   },
 * }
 */
const tracker = store => next => action => {
  if (!store) return next(action);
  const result = next(action);
  const trackEvent = getTrackEvent();

  const gaAction = actionMap[action.type];
  if (gaAction) {
    trackEvent(typeof gaAction === "function" ? gaAction(action) : gaAction);
  }

  return result;
};

export default tracker;



// WEBPACK FOOTER //
// ./assets/shared/middleware/tracker.js